<script setup>
import { usePromotionStore } from '~/stores/promotion'
import PromoCode from '~/components/PromoCode'
import OnEveryDevice from '~/components/OnEveryDevice'
import OldHowItWorks from '~/components/howItWorks/OldHowItWorks'
import BooksCarousel from '~/components/books/BooksCarousel'

definePageMeta({
  layout: 'promotion',
  middleware: 'promo'
})

const config = useRuntimeConfig()
const { $label } = useNuxtApp()
const verzilverPage = {
  slug: PAGES.redeemPageSlug,
  headerBackgroundLargeImageUrl: `${config.public.IMAGE_RESIZE_URL}?image=fe-assets/verzilver-banner-img.jpg`,
  headerBackgroundSmallImageUrl: `${config.public.IMAGE_RESIZE_URL}?image=fe-assets/verzilver-banner-img-small.jpg`,
  headerSubtitle: $label('promotions.verzilverPage.headerSubtitle'),
  headerTitle: $label('promotions.verzilverPage.headerTitle'),
  contentFreeText: $label('promotions.verzilverPage.contentText')
}
const promotionStore = usePromotionStore()
const route = useRoute()
const slug = computed(() => route.params.slug)
useAsyncData(() => {
  if (slug.value === PAGES.redeemPageSlug) {
    promotionStore.setLandingPage(verzilverPage)
  }

  return true
})
const landingPage = computed(() => promotionStore.landingPage)

useHead({
  title: `${landingPage.value.headerTitle} • Bookchoice`,
  meta: [
    {
      name: 'description',
      content: landingPage.value.headerSubtitle
    }
  ]
})

async function onPromoCodeVerification() {
  await navigateTo('/promo/aanmelden')
}
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <PromotionHeader />
    <div data-nw="promo-b2b-landing-page">
      <div class="container pb-32 pb-lg-48">
        <div class="row">
          <div class="col-lg-8 col-xl-6 mx-auto">
            <div class="text-center">
              <h3>{{ landingPage.contentTitle }}</h3>
              <p class="mb-0" v-html="landingPage.contentFreeText" />
            </div>
          </div>
        </div>
      </div>

      <div class="container px-0 px-md-3 mb-72 mb-lg-80 pb-lg-16">
        <div class="row justify-content-center mx-0">
          <div class="col-lg-8 col-xl-6">
            <PromoCode
              :title="$label('redeem.title')"
              :msg="$label('redeem.promo.text')"
              :on-promo-code-verification="onPromoCodeVerification"
            />
          </div>
        </div>
      </div>

      <div class="book-carousel__wrapper">
        <BooksCarousel />
      </div>

      <div class="container mt-lg-16 mb-lg-48">
        <div class="row justify-content-center pt-56 pt-lg-80 pb-72 pb-lg-80">
          <div class="col-12">
            <OldHowItWorks variant="b2b" />
          </div>
        </div>
      </div>

      <div class="mb-72 mb-lg-80 pb-lg-16">
        <OnEveryDevice />
      </div>

      <div class="container px-0 pb-32 pb-lg-48">
        <div class="row justify-content-center mx-0">
          <div class="col-lg-8 col-xl-6">
            <PromoCode
              :title="$label('redeem.title')"
              :msg="$label('redeem.promo.text')"
              :on-promo-code-verification="onPromoCodeVerification"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.book-carousel__wrapper {
  background-color: $grey-01;
  padding: 56px 0 1px;
}

@include media-breakpoint-up(lg) {
  .book-carousel__wrapper {
    padding: 96px 0 1px;
  }
}
</style>
